<template>
  <div class="sales-history__toolbar">
    <label class="sales-history__search">
      <Search :size="18" />

      <input
        :value="searchQuery"
        @input="$emit('update:searchQuery', $event.target.value)"
        type="search"
        placeholder="Найти товар или продажу"
        aria-label="Поиск по товару или номеру продажи"
      >
    </label>

    <div class="sales-history__totals">
      <span>Продаж <b>{{ totalSales }}</b></span>
      <span>На сумму <b>{{ priceToFormat(totalPrice) }}</b></span>
    </div>
  </div>
</template>

<script>
import { Search } from 'lucide-vue'

import { priceToFormat } from '@/helper'

export default {
  name: 'HistoryToolbar',
  components: { Search },
  props: {
    totalSales: {
      type: Number,
      default: 0
    },
    totalPrice: {
      type: Number,
      default: 0
    },
    searchQuery: {
      type: String,
      default: ''
    }
  },
  methods: {
    priceToFormat
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
